<section class="bg-mystic notice-section">
  @defer(on viewport) {
  <div class="max-w-[900px] w-[90vw] sm:w-[80vw] mx-auto">
    <h2 class="text-xl lg:text-2xl flex mb-5">
      <img ngSrc="assets/images/place.png" class="bg-red-500" alt="notice icon" width="45" height="45" />
      <span class="font-bold text-red-500 lh-45px ml-2">Notice!</span>
    </h2>
    <div class="h5-responsive body">
      @if(noticeSection) {
      <div [innerHTML]="noticeSection.data"></div>
      }
    </div>
  </div>
  }@placeholder {
  <div class="spinner-center">
    <mat-spinner></mat-spinner>
  </div>
  }
</section>
